import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import { get, post } from "@/axios/index";
import store from "./store/index";
import api from "@/config/apis.js";
import utils from "@/utils/index.js";
import "./plugins/element.js";
import "./assets/scss/common.scss";
import Element from "element-ui";
// import "element-ui/lib/theme-chalk/index.css";
import '@/element-ui/theme/index.css';
import GCard from '@/components/card'
import GSvgIcon from '@/components/GSvgIcon'
import './icons' // icon
import { Toast } from 'vant';
import 'vant/lib/index.css'
Vue.use(Toast);
Vue.use(Element);
Vue.config.productionTip = false;
Vue.prototype.$api = api;
Vue.prototype.$utils = utils;
Vue.prototype.$get = get;
Vue.prototype.$post = post;

Vue.component('g-card', GCard)
Vue.component('g-icon', GSvgIcon)

new Vue({
	router,
	store,
	render: (h) => h(App),
}).$mount("#app");
